import { UIColor } from "uicore-ts"
import { CBColor } from "../CBColor"


/**
 * RHColor
 *
 * Extended to support the full Bootstrap color palette with specific
 * RGB values required for focus rings and state variations.
 */
export class RHColor extends UIColor {
    
    
    static get backgroundColor() {
        return new UIColor("#f6f4f2")
    }
    
    
    // The Purple color used for the CTA button
    // Extracted from: rgb(201, 79, 160) (The "Anna tagasisidet" button)
    static get callToActionColor() {
        return new UIColor("#c94fa0")
    }
    
    
    static get surface() {
        return new UIColor("#ffffff")
    }
    
    static get background() {
        return new UIColor("#f9fafb")
    }
    
    static get textPrimary() {
        return new UIColor("#111827")
    }
    
    static get textSecondary() {
        return new UIColor("#6b7280")
    }
    
    static get border() {
        return new UIColor("#e5e7eb")
    }
    
    static get borderFocus() {
        return CBColor.primaryTintColor
    }
    
    static get rowHover() {
        return new UIColor("#f3f4f6")
    }
    
    static get shadow() {
        return new UIColor("rgba(0, 0, 0, 0.05)")
    }
}
